import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  removeSiteUserSuccessAction
} from '../../reducers/actions';
import { UserService } from '../../services';
import { apiErrorHandling } from '../../utils/epics/apiErrorHandling';
import updateErrorMsgAction from '../../reducers/error-banner/actions/updateErrorMsg';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_SITE_USER),
    switchMap(action =>
      UserService.deleteSiteUser(action.siteUserId, store).pipe(
        map(() => removeSiteUserSuccessAction(action.siteUserId)),
        catchError(apiErrorHandling(updateErrorMsgAction))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/users/deleteSiteUser.js